import './new-referral-setting.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormReferralSetting from "../form-referral-setting/form-referral-setting";
import { useNewReferralSetting } from './new-referral-setting.hook';

export function NewReferralSetting() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewReferralSetting();

  return (
    <div id="NewReferralSetting" className="referral-setting">
      <HeaderContent
        title={<h1>New Referral Setting</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormReferralSetting />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewReferralSetting;